import React from "react";
import PropTypes from "prop-types";
import { Dropdown, Label } from "./Inputs";
import ConfirmationDialog from "./ConfirmationDialog";

const getState = (model) => {
  return {
    status_id: model.status_id || 2,
    error: {},
  };
};

function StatusForm({
  forwardedRef,
  className = "",
  label = "Status",
  model = {
    status_id: 2,
  },
  objectTitle = "Servicepartner",
  namePrefix = "",
  statusActions,
  statusIds,
  statusLabels,
  disabled,
  iseditable,
  isDisabled,
}) {
  const dialogRef = React.useRef(null);
  const [state, setState] = React.useState(getState(model));

  React.useEffect(() => {
    setState(getState(model));
  }, [model]);

  const validate = React.useCallback(
    (noValidate) => {
      const { error, ...newModel } = state;
      let isValid = true;
      Object.keys(error).forEach((key) => {
        if (error[key] !== undefined && newModel[key] === null) {
          error[key] = true;
          isValid = false;
        }
      });
      setState((prev) => ({ ...prev, error }));
      if (!noValidate && !isValid) {
        return null;
      }
      return { ...newModel };
    },
    [state],
  );

  const getModel = React.useCallback(
    (noValidate) => validate(noValidate),
    [validate],
  );
  React.useImperativeHandle(forwardedRef, () => ({ getModel }));

  const onChange = React.useCallback(
    (status_id) => {
      const action = statusActions[`${status_id}`];
      const tokens = objectTitle.split(" ");
      let objectName = objectTitle;
      if (tokens.length > 1) {
        objectName = tokens.slice(1).join(" ");
      }
      dialogRef.current.show(
        true,
        {
          title: `${objectName} ${action}`,
          text: `Wollen Sie ${objectTitle} wirklich ${action}?`,
        },
        () =>
          setState((prev) => ({
            ...prev,
            status_id,
            error: {
              ...prev.error,
              status_id: null,
            },
          })),
      );
    },
    [statusActions, objectTitle, namePrefix, dialogRef],
  );

  const options = Object.keys(statusIds).map((key) => ({
    label: statusLabels[`${statusIds[key]}`],
    value: statusIds[key],
  }));

  console.log(
    `StatusForm() disabled ${disabled} isDisabled: ${isDisabled} iseditable: ${iseditable}`,
  );
  return (
    <div className={className}>
      <Label htmlFor={`${namePrefix}status_id`} noMargin>
        {label}
      </Label>
      <Dropdown
        id={`${namePrefix}status_id`}
        data-test-id={`${namePrefix}status_id`}
        className="w3-block w3-border"
        value={state.status_id}
        placeholder="Status auswählen"
        options={options}
        onChange={(event) => onChange(event.value)}
        disabled={
          disabled ||
          isDisabled ||
          (iseditable !== undefined && iseditable !== "true")
        }
        // appendTo={document.getElementById(`${namePrefix}status_id`)}
        // showClearz
      />
      <ConfirmationDialog ref={dialogRef} />
    </div>
  );
}

StatusForm.propTypes = {
  className: PropTypes.string,
  model: PropTypes.shape({
    status_id: PropTypes.number,
  }),
  disabled: PropTypes.bool,
  label: PropTypes.string,
  statusIds: PropTypes.shape({}),
  statusLabels: PropTypes.shape({}),
  statusActions: PropTypes.shape({}),
  objectTitle: PropTypes.string,
  namePrefix: PropTypes.string,
  isDisabled: PropTypes.bool,
  iseditable: PropTypes.string,
};

export default React.forwardRef((props, ref) => (
  <StatusForm {...props} forwardedRef={ref} />
));
